import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AuthClient } from '@biz-nest/auth-client';
import { CommerceClient } from '@biz-nest/commerce-client';
import { NotificationClient } from '@biz-nest/notification-client';
import { AppNameService, WebStorageService } from '@front-shared-lib';
import { ManagerClient } from '@main-shared-lib';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  currency = 'USD';

  constructor(
    private storage: WebStorageService,
    private apNme: AppNameService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  setCurrency(currency: string) {
    if (!currency) {
      return;
    }
    this.currency = currency;
    const headers = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'x-currency': currency
    };

    AuthClient.ehttp.appendToHeaders(headers);
    CommerceClient.ehttp.appendToHeaders(headers);
    NotificationClient.ehttp.appendToHeaders(headers);
    ManagerClient.ehttp.appendToHeaders(headers);
  }

  changeCurrency(newCurrency: string, forceReload = true) {
    if (!newCurrency) {
      return;
    }
    this.setCurrency(newCurrency);
    this.storage.set(this.apNme + '_currency', newCurrency);
    // Trigger a full app refresh without changing route
    if (isPlatformBrowser(this.platformId) && forceReload) {
      window.location.reload();
    }
  }

  getStorageCurrency() {
    return this.storage.get(this.apNme + '_currency');
  }
}
